import React, { Component } from 'react';
import './iamExUsContent.css';
import {actionArray as allActions} from '../../utils/allActionsArray.json';
import IamExUsActionRow from './iamExUsActionRow/iamExUsActionRow.js';
import IamExUsEventRow from './iamExUsEventRow/iamExUsEventRow.js';
import {Auth} from 'aws-amplify';
import AWS from 'aws-sdk';

class IamExUsContent extends Component {

  state = {
    expandEventTable: true,
    revokePermissionCheck: false
  };

  componentDidMount() {

  };

  render() {

    const actionFilter = action => {
      if (this.props.serviceFilter !== '') {
        const regex = new RegExp(`${this.props.serviceFilter.replace('*', '.*')}`);
        return regex.test(action);
      } else return false;
    };

    return (
      <div className="IamExUsContentPage">
        <div className="IamExUsContentDiv UserInfo">
          <div>
            <h1>{this.props.user.UserName}</h1>
            <h2>{`${this.props.user.Account} (${this.props.user.AccountId})`}</h2>
          </div>
          <div>
            <button onClick={this.revokeUserPermissionCheck}>{this.state.revokePermissionCheck ? 'Cancel' : 'Revoke All User Permissions'}</button>
            {this.state.revokePermissionCheck && <button onClick={this.revokeUserPermission}>Confirm Revoke All User Permissions</button>}
          </div>
        </div>
        <div className="IamExUsContentDiv EventTable">
          <div className="ButtonDiv" onClick={() => this.handleExpand('EventTable')}>
            <h2>Recent Events</h2>
          </div>
          {
            this.state.expandEventTable &&
            <table className="EventTable">
              <tbody>
                <tr>
                  <th>Region</th>
                  <th>Event Name</th>
                  <th>Event Source</th>
                  <th>Time</th>
                  <th>Event Type</th>
                  <th>Access Key</th>
                </tr>
                {this.props.events.map(event => {
                  return <IamExUsEventRow key={event.eventID} event={event}/>;
                })}
              </tbody>
            </table>
          }
          <div className="ButtonDiv" onClick={this.downloadEvents}>
            <h3>{this.props.nexttoken === 'FINISHED' ? 'All Events Obtained' : 'Get Events'}</h3>
          </div>
          <div className="ButtonDiv" onClick={this.downloadAllEvents}>
            <h3>{this.props.nexttoken === 'FINISHED' ? 'All Events Obtained' : 'Get All Events'}</h3>
          </div>
        </div>
        <div className="IamExUsContentDiv ActionTable">
          <div className="ButtonDiv" onClick={() => this.handleExpand('ActionTable')}>
            <h2>Action Permissions</h2>
          </div>
          {
            this.state.expandActionTable &&
            <table className="ActionTable">
              <tbody>
                <tr>
                  <th>Service</th>
                  <th>Action</th>
                  <th>Type</th>
                  <th>Allowed</th>
                  <th>Denied</th>
                </tr>
                {allActions.filter(actionFilter).map(action => {
                  return <IamExUsActionRow key={action} action={action} user={this.props.user}/>;
                })}
              </tbody>
            </table>
          }
        </div>
      </div>
    );
  };

    revokeUserPermissionCheck = () => {
      this.setState({revokePermissionCheck: !this.state.revokePermissionCheck});
    };

    revokeUserPermission = () => {

      Auth.currentCredentials()
      .then(credentials => {
        const Lambda = new AWS.Lambda({credentials: Auth.essentialCredentials(credentials), region: 'eu-west-1'});
        const Payload = JSON.stringify({
          'username': this.props.user.UserName,
          'accountId': this.props.user.AccountId
        });
        const alias = process.env.REACT_APP_STAGE === 'development' ? 'Dev' : 'Prod';
        return Lambda.invoke({FunctionName: 'iam-deny-all-actions', Payload, Qualifier: alias}).promise();
      })
      .then(res => {
        if (res.Payload === '"SUCCESS"') {
          this.props.refreshIamInformation();
        }
      })
      .catch(err => {
        console.log(err);
      });

    };

    handleExpand = section => {
      this.setState({[`expand${section}`]: !this.state[`expand${section}`]});
    };

    downloadEvents = () => {
      this.props.downloadEvents();
    }

    downloadAllEvents = () => {
      if (this.props.nexttoken !== 'FINISHED') {
        this.props.downloadEvents()
        .then(res => {
          this.downloadAllEvents();
        });
      }
    }

};

export default IamExUsContent;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExUsers/iamExUsContent/iamExUsContent.js